<script>
  import other from '../functions-common/other';
  import createMapsStore from '../stores/project-maps'
  import Map from './Map.svelte'
  import Score from './Score.svelte'

  const substituteVars = other.substituteVars;

  export let id;
  export let types;
  export let scores;
  export let loading = false;

  let openedMaps = [];

  let selectedType = 'global';

  function onTypeSelected(type) {
    selectedType = type;
  }

  function toggleMaps(mapId) {
    if (openedMaps.includes(mapId))
      openedMaps = openedMaps.filter(mId => mId !== mapId);
    else
      openedMaps = openedMaps.concat([mapId]);
  }

  function onTypesOrSelectedUpdated() {
    if (!types || !Array.isArray(types)) return;

    if (!types.find(t => t.type === selectedType)) selectedType = types.length ? types[0].type : null;
  }

  function getMaps(scores, type) {
    if (!scores || !Array.isArray(scores) || !scores.length) return null;

    return Object.values(scores.reduce((cum, s) => {
      if (!((type && type.type === 'global') || (type && type.type === s.category_name))) return cum;

      const {
        author_name,
        category_id,
        category_name,
        cover_url,
        difficulty,
        hash,
        level_author,
        map_id,
        name,
        song_id,
        ...score
      } = s;

      if (!cum[map_id]) cum[map_id] = {
        author_name,
        category_id,
        category_name,
        cover_url,
        difficulty,
        hash,
        level_author,
        map_id,
        name,
        song_id,
        scores: [],
      }

      cum[map_id].scores.push(score);

      return cum;
    }, {}))
      .map(m => {
        m.scores = m.scores.filter(s => s.score).sort((a, b) => b.acc - a.acc)
        return m;
      })
      .sort((a, b) => a.name.localeCompare(b.name))
  }

  $: projectMaps = id ? createMapsStore(id) : null;
  $: onTypesOrSelectedUpdated(types, selectedType);
  $: currentType = types && selectedType ? types.find(t => t.type === selectedType) : null;
  $: maps = getMaps(scores, currentType) ?? $projectMaps;
</script>

<h3>
  {#each types as type}
    <button type="button" class={`nes-btn ${type.type === selectedType ? 'is-primary' : 'is-default'}`}
            on:click={() => onTypeSelected(type.type)}>{type.name === 'Global' ? 'All' : type.name}</button>
  {/each}
</h3>

{#if maps && maps.length}
  <section class="maps">
    {#each maps as map}
      <Map {map} on:click={() => map.scores && map.scores.length > 3 ? toggleMaps(map.map_id) : null}>
        <span class="map-footer" slot="footer">
          <span class="category-name">
            {map.category_name && map.category_name.length ? map.category_name[0].toUpperCase() + map.category_name.substr(1): ''}
          </span>
          {#if map.scores && map.scores.length > 3}
            <span class="more" title="Show/hide all scores">
              <span class="chevron">
                <img src={"/assets/images/" + (openedMaps.includes(map.map_id) ? 'chevron-down-black' : 'chevron-right-black') + ".png"}/>
              </span>
            </span>
          {/if}
        </span>
      </Map>
      <section class="scores nes-container is-rounded">
        {#if map.scores && map.scores.length}
          {#each map.scores.slice(0, openedMaps.includes(map.map_id) ? map.scores.length : 3) as score}
            <Score {score} />
          {/each}
        {:else}
          No scores.
        {/if}
      </section>
    {/each}
  </section>
{:else if !loading}
  <p>It looks like leaderboard doesn't exist yet.</p>
{/if}

<style>
    h3 {
        margin-bottom: 2rem;
        text-align: center;
    }

    .maps {
        display: block;
        color: #222;
        background-color: #aaa;
        padding: .5rem;
        margin-bottom: 2rem;
    }

    .maps :global(.map-score) {
        margin-bottom: 0.25rem!important;
    }

    .scores {
        padding: 1rem .5rem .5rem .5rem;
        /*margin: 0 .5rem 2rem .5rem;*/
        margin-top: .25rem;
        margin-bottom: 2rem;
    }

    .more {
        position: relative;
        top: -2px;
        width: 1.25rem !important;
        height: 1.25rem;
        cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAzElEQVRYR+2X0Q6AIAhF5f8/2jYXZkwEjNSVvVUjDpcrGgT7FUkI2D9xRfQETwNIiWO85wfINfQUEyxBG2ArsLwC0jioGt5zFcwF4OYDPi/mBYKm4t0U8ATgRm3ThFoAqkhNgWkA0jJLvaOVSs7j3qMnSgXWBMiWPXe94QqMBMBc1VZIvaTu5u5pQewq0EqNZvIEMCmxAawK0DNkay9QmfFNAJUXfgGgUkLaE7j/h8fnASkxHTz0DGIBMCnBeeM7AArpUd3mz2x3C7wADglA8BcWMZhZAAAAAElFTkSuQmCC) 14 0, pointer;
    }

    .chevron{
        position: relative;
        width: 14px;
        height: 14px;
    }

    .map-footer {
        display: contents;
    }

    .category-name {
        margin-right: 1rem;
    }

    @media screen and (max-width: 767px) {
        h3 {
            text-align: center;
        }

        .category-name {
            display: none;
        }
    }
</style>